export default {
  getUser: state => state.user,
  getConfig: state => state.config,
  getGuid: state => state.guid,
  getCaptcha: state => state.showCaptcha
};
